module.exports = __webpack_public_path__ + "img/generica_winter.447dd342.svg";